/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */

import type { SvgIconComponent } from "@material-ui/icons";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import { capitalize } from "lodash";
import { TFunction } from "react-i18next";
import { getStarTreeCloudUrl } from "../../../utils/environment/environment.utils";

export const getNavbarLinks = (
    t: TFunction,
    showCloudPortal?: boolean
): Array<{
    label: string;
    link: string;
    icon: SvgIconComponent;
}> => {
    const links = [
        {
            label: t("label.star-tree-community-slack"),
            link: t("url.star-tree-community-slack"),
            icon: PeopleOutlineIcon,
        },
        {
            label: capitalize(t("label.documentation-lowercase")),
            link: t("url.startree-dm-docs"),
            icon: FileCopyIcon,
        },
    ];

    const cloudPortalUrl = getStarTreeCloudUrl();
    if (showCloudPortal && cloudPortalUrl) {
        links.unshift({
            label: capitalize(t("label.home")),
            link: cloudPortalUrl + "/new-user",
            icon: OpenInNewIcon,
        });
    }

    return links;
};
